import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  BodyText,
  CaptionText,
  Card,
  Icon,
} from '@paypalcorp/pp-react';
import { Button } from '@swift-paypal/pp-react';
import constants from '../../../constants';
import { interpolate } from '../../../utils/string-helper';
import { trackClick, trackPage } from '../../../utils/fpti-helper';
import PreApprovalBadge from './preapproval-badge/preapproval-badge';
import './preapproval-tile.less';

const PreApprovalTile = ({
  loan,
  renewFunc,
  approvalCategory,
  offerExpiryDate,
}) => {
  const { preapproval } = constants;
  const content = preapproval.category[approvalCategory];
  const superscriptText = preapproval.superScriptText;
  const campaignId = window.localStorage.getItem('utm');

  const renew = () => {
    trackClick({ page: 'PreApproval', eventName: 'getStartedClicked', campaignId });
    renewFunc(loan.accountId);
  };

  /**
   * No content for VERY_LOW and INELIGIBLE categories. No banner should be shown for those categories.
   */
  useEffect(() => {
    if (content) {
      trackPage({ page: 'PreApproval', eventName: 'bannerDisplayed', campaignId });
    }
  }, [content]);

  if (!content) {
    return null;
  }

  return (
    <div>
      <Card className="preApprovalTile">
        <div>
          <Icon name="loans" width="3rem" height="3rem" color="success" />
        </div>
        <div className="preApprovalTileTextWrapper">
          <BodyText strong className="preApprovalTileTitle">
            {interpolate(content.header, {
              superscript: (
                <sup>{superscriptText}</sup>
              ),
            })}
          </BodyText>
          <div>
            <PreApprovalBadge text={content.badgeText} />
          </div>
          <CaptionText className="preApprovalTileSubtitle">
            {interpolate(content.subHeader, {
              highlight: (
                <strong>{`${content.approvalPercentage}%+`}</strong>
              ),
              offerExpiryDate: (
                <strong>{new Date(offerExpiryDate).toLocaleDateString()}</strong>
              ),
            })}
          </CaptionText>
          <div>
            <Button secondary type="button" className="preApprovalGetStartedBtn" onClick={renew}>
              Get Started
            </Button>
          </div>
        </div>
      </Card>
      <CaptionText>
        {interpolate(content.disclaimer, {
          superscript: (
            <sup>{superscriptText}</sup>
          ),
        })}
      </CaptionText>
    </div>
  );
};

PreApprovalTile.propTypes = {
  loan: PropTypes.shape({
    accountName: PropTypes.string,
    accountId: PropTypes.string,
  }).isRequired,
  renewFunc: PropTypes.func.isRequired,
  approvalCategory: PropTypes.string,
  offerExpiryDate: PropTypes.string,
};

PreApprovalTile.defaultProps = {
  approvalCategory: undefined,
  offerExpiryDate: undefined,
};

export default PreApprovalTile;
